export const iconFontAwesomeConstructionSheetPlastic = (
	<i className="fa-solid fa-sheet-plastic"></i>
);
